module.exports = __webpack_public_path__ + "img/guangfu eletronics.19d303e6.png";